'use client';

import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/config/react-query';

export function APIProvider({ children }: { children: React.ReactNode }) {
  return <QueryClientProvider client={queryClient}> {children} </QueryClientProvider>;
}
